export default __webpack_public_path__ + "static/media/7.2.1f39484b.mp3";